import React from "react";
import ExpectedCampaigns from "../modules/ExpectedCampaigns/ExpectedCampaigns";

export default function ExpectedCampaignsPage() {
  return <ExpectedCampaigns />;
}